import { Button, Form } from "antd";
import { ReactNode } from "react";
import AddIcon from "../../../assets/icons/AddIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import ViewIcon from "../../../assets/icons/ViewIcon";
import SidebarLayout from "../../../layouts/SidebarLayout";

export default function PricingFaq() {
  const [form] = Form.useForm();
  const onFinish = (values: any) => {};
  return (
    <SidebarLayout title="Website CMS - Footer">
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <div className="grid md:grid-cols-260 gap-6 ">
          <div className="bg-white border border-extra-light p-6  rounded-md max-h-[282px]">
            <div className="justify-between items-center gap-2.5 flex">
              <h1 className="text-[#2d3643] text-xl font-semibold leading-loose">
                App list
              </h1>

              <Button
                type="primary"
                className="!h-[38px] w-[38px] flex justify-center items-center"
              >
                <AddIcon />
              </Button>
            </div>

            <div className="mt-6 space-y-2.5">
              <SideMenu menuText="digiGO" />
              {/* <SideMenu menuText="EDOTCO" />
              <SideMenu menuText="Ticketing System" /> */}
            </div>
          </div>

          <div className="bg-white border border-extra-light p-6  rounded-md">
            <div
              className={`bg-[#F0F3F9] flex justify-between items-center border-b px-3 py-2.5 border-[#8897AE] font-medium rounded-t-md`}
            >
              <h4 className="text-display-body ">FAQs</h4>
              <div className="text-display-body ">Action</div>
            </div>
            {/* <InfoItemTwo
              title="Pricing"
              children={
                <div className="flex justify-between items-center gap-x-1.5">
                  <FaqElement />
                </div>
              }
            /> */}
            <FaqElement
              title="Do I really have access to hundreds of Products and modules for a single price?"
              icons={
                <div className="flex justify-center items-center gap-x-1.5 ">
                  <span className="text-[#1DB469] rounded-full border-2 border-[#8FE7B8] border-solid  w-7 h-7  flex justify-center items-center">
                    <ViewIcon />
                  </span>
                  <span className=" text-[#4A72FF] w-7 h-7 rounded-full border-2 border-solid border-[#B4C4FF] flex justify-center items-center">
                    <EditIcon />
                  </span>
                  <span className="text-[#FF574D] w-7 h-7 rounded-full border-2 border-solid border-[#FFC5C1] flex justify-center items-center">
                    <DeleteIcon />
                  </span>
                </div>
              }
            />
            <FaqElement
              title="What's included in the subscription?"
              icons={
                <div className="flex justify-center items-center gap-x-1.5 ">
                  <span className="text-[#1DB469] rounded-full border-2 border-[#8FE7B8] border-solid  w-7 h-7  flex justify-center items-center">
                    <ViewIcon />
                  </span>
                  <span className=" text-[#4A72FF] w-7 h-7 rounded-full border-2 border-solid border-[#B4C4FF] flex justify-center items-center">
                    <EditIcon />
                  </span>
                  <span className="text-[#FF574D] w-7 h-7 rounded-full border-2 border-solid border-[#FFC5C1] flex justify-center items-center">
                    <DeleteIcon />
                  </span>
                </div>
              }
            />
            <FaqElement
              title="How to upgrade from the digiGO Free plan to a Standard or Custom plan?"
              icons={
                <div className="flex justify-center items-center gap-x-1.5 ">
                  <span className="text-[#1DB469] rounded-full border-2 border-[#8FE7B8] border-solid  w-7 h-7  flex justify-center items-center">
                    <ViewIcon />
                  </span>
                  <span className=" text-[#4A72FF] w-7 h-7 rounded-full border-2 border-solid border-[#B4C4FF] flex justify-center items-center">
                    <EditIcon />
                  </span>
                  <span className="text-[#FF574D] w-7 h-7 rounded-full border-2 border-solid border-[#FFC5C1] flex justify-center items-center">
                    <DeleteIcon />
                  </span>
                </div>
              }
            />
            <FaqElement
              title="Where can I get implementation services, and how much does it cost?"
              icons={
                <div className="flex justify-center items-center gap-x-1.5 ">
                  <span className="text-[#1DB469] rounded-full border-2 border-[#8FE7B8] border-solid  w-7 h-7  flex justify-center items-center">
                    <ViewIcon />
                  </span>
                  <span className=" text-[#4A72FF] w-7 h-7 rounded-full border-2 border-solid border-[#B4C4FF] flex justify-center items-center">
                    <EditIcon />
                  </span>
                  <span className="text-[#FF574D] w-7 h-7 rounded-full border-2 border-solid border-[#FFC5C1] flex justify-center items-center">
                    <DeleteIcon />
                  </span>
                </div>
              }
            />
            <div className="flex justify-end items-center">
              <Button className="middle-button mt-6 " type="primary">
                Update
              </Button>
            </div>
          </div>
        </div>
      </Form>
    </SidebarLayout>
  );
}

function FaqElement({ title, icons }: elementType) {
  return (
    <div
      className={`flex justify-between items-center border px-3 py-2.5 border-extra-light border-t-0 font-medium  `}
    >
      <h4 className={`text-display-body`}>{title}</h4>
      <div className="p-3">{icons}</div>
    </div>
  );
}

type elementType = {
  title: string;
  icons: ReactNode;
};

type sideText = {
  menuText: string;
};

function SideMenu({ menuText }: sideText) {
  return (
    <>
      <div className="bg-[#F9FAFB] py-4 px-4 rounded-lg text-primary font-medium border-2 border-solid border-primary">
        {menuText}
      </div>
    </>
  );
}
